import React, { useState } from "react";
import { axInst } from "../../../Components/Login/Service";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";

import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";
import ModalMuiTable from "../../../Components/Modals/ModalMuiTable.jsx";
import PipelineFilter from "../../../Components/Filters/PipelineFilter.jsx";
import { FaRegHandPointer } from "react-icons/fa";

// ---------- API Calls ----------
const fetchMTDFunnel = async (body) => {
  const res = await axInst.post("/pipeline/mtd-funnel", body);
  return res.data.mtd_funnel;
};

const fetchLmtdFunnel = async (body) => {
  const res = await axInst.post("/pipeline/lmtd-funnel", body);
  return res.data.lmtd_funnel;
};

const fetchCarryFunnel = async (body) => {
  const res = await axInst.post("/pipeline/carryover-funnel", body);
  return res.data.carry_over_funnel;
};

const fetchTotalFunnel = async (body) => {
  const res = await axInst.post("/pipeline/total-funnel", body);
  return res.data.total_funnel;
};

const fetchTotalLmtdFunnel = async (body) => {
  const res = await axInst.post("/pipeline/total_lmtd_funnel", body);
  return res.data.lmtd_total_funnel;
};

// ---------- Single Funnel Chart ----------
// const FunnelChartDigram = ({ data, title, onC2Click }) => {
//   const layers = [
//     { name: "C0", color: "bg-teal-400", width: "w-full" },
//     { name: "C1", color: "bg-purple-600", width: "w-5/6" },
//     { name: "C1A", color: "bg-sky-400", width: "w-4/6" },
//     { name: "C2", color: "bg-orange-400", width: "w-3/6", clickable: true },
//     { name: "Retail", color: "bg-pink-400", width: "w-[43%]" },
//   ];

//   if (!data) return <div>Data not available</div>;

//   return (
//     <div className="flex flex-col items-center relative">
//       <WaterMark />
//       <header className="align-left text-base font-semibold text-[#4c4c4c]">
//         {title}
//       </header>

//       <div className="relative w-52">
//         {layers.map((layer, index) => (
//           <div
//             key={index}
//             className={`${layer.width} h-[25px] ${
//               layer.color
//             } mx-auto mt-2 rounded-t-full rounded-b-full flex items-center justify-center text-white text-sm whitespace-nowrap ${
//               layer.clickable ? "cursor-pointer hover:opacity-80" : ""
//             }`}
//             title={`${layer.name}: ${data[layer.name]}`}
//             onClick={() => {
//               if (layer.clickable && onC2Click) {
//                 onC2Click(title, layer.name); // pass funnel type (MTD, Carry Over) + layer
//               }
//             }}
//           >
//             {layer.name}: {data[layer.name]}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// ---------- Single Funnel Chart ----------

// ---------- Single Funnel Chart ----------
const FunnelChartDigram = ({ data, title, onC2Click }) => {
  // Check if this funnel type should allow clicking
  const isClickableFunnel = title === "MTD" || title === "Carry Over";

  const layers = [
    { name: "C0", color: "bg-teal-400", width: "w-full" },
    { name: "C1", color: "bg-purple-600", width: "w-5/6" },
    { name: "C1A", color: "bg-sky-400", width: "w-4/6" },
    {
      name: "C2",
      color: "bg-orange-400",
      width: "w-3/6",
      clickable: isClickableFunnel, // 🔥 Only clickable for MTD & Carry Over
    },
    { name: "Retail", color: "bg-pink-400", width: "w-[43%]" },
  ];

  if (!data) return <div>Data not available</div>;

  return (
    <div className="flex flex-col items-center relative">
      <WaterMark />
      <header className="align-left text-base font-semibold text-[#4c4c4c]">
        {title}
      </header>

      <div className="relative w-52">
        {layers.map((layer, index) => (
          <div
            key={index}
            className={`${layer.width} h-[25px] ${layer.color}
    mx-auto mt-2 rounded-t-full rounded-b-full flex items-center
    justify-center text-white text-sm whitespace-nowrap
    ${layer.clickable ? "cursor-pointer hover:opacity-90" : "cursor-default"}`}
            title={
              layer.name === "C2" && layer.clickable
                ? `${layer.name}: ${data[layer.name]} \n${
                    title === "MTD"
                      ? "MTD C2 Pipeline Customer Details"
                      : "Carryover C2 Pipeline Customer Details"
                  }`
                : `${layer.name}: ${data[layer.name]}`
            }
            onClick={() => {
              if (layer.clickable && onC2Click) {
                onC2Click(title, layer.name);
              }
            }}
          >
            <div className="flex items-center">
              {layer.name}: {data[layer.name]}
              {/* Hand icon only when clickable */}
              {layer.clickable && layer.name === "C2" && (
                <span className="ml-1 text-white text-sm">
                  <FaRegHandPointer />
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ---------- Main Component ----------
const MultipleFunnelCharts = () => {
  const { data, submitted } = useSelector((e) => e.filtersPipeline);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalApi, setModalApi] = useState("");
  const [modalHeading, setModalHeading] = useState("");

  const { data: mtdFunnelData, isLoading: isLoadingMtd } = useQuery({
    queryKey: ["mtd_funnel", submitted],
    queryFn: () => fetchMTDFunnel(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: lmtdFunnelData, isLoading: isLoadingLmtd } = useQuery({
    queryKey: ["lmtd_funnel", submitted],
    queryFn: () => fetchLmtdFunnel(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: totalFunnelData, isLoading: isLoadingTotal } = useQuery({
    queryKey: ["total_funnel", submitted],
    queryFn: () => fetchTotalFunnel(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: carryFunnelData, isLoading: isLoadingCarry } = useQuery({
    queryKey: ["carry_funnel", submitted],
    queryFn: () => fetchCarryFunnel(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: totalLmtdFunnelData, isLoading: isLoadingTotalLmtd } = useQuery(
    {
      queryKey: ["total_lmtd", submitted],
      queryFn: () => fetchTotalLmtdFunnel(data),
      refetchInterval: 300000,
      refetchIntervalInBackground: true,
    },
  );

  const isLoading =
    isLoadingLmtd ||
    isLoadingTotal ||
    isLoadingMtd ||
    isLoadingCarry ||
    isLoadingTotalLmtd;

  if (isLoading) {
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  }

  const funnelData = [
    mtdFunnelData,
    carryFunnelData,
    totalFunnelData,
    lmtdFunnelData,
    totalLmtdFunnelData,
  ];
  const titles = ["MTD", "Carry Over", "Total", "LMTD", "Total LMTD"];

  // 🔸 Handle C2 click event
  const handleC2Click = (funnelType, layerName) => {
    if (layerName === "C2") {
      if (funnelType === "MTD") {
        setModalApi("pipeline/c2_report");
        setModalHeading("MTD C2 Pipeline Customer Details");
        setIsModalOpen(true);
      } else if (funnelType === "Carry Over") {
        setModalApi("pipeline/c2_carry_report");
        setModalHeading("Carryover C2 Pipeline Customer Details");
        setIsModalOpen(true);
      }
    }
  };

  return (
    <>
      <div className="md:flex block justify-center">
        {funnelData.map((data, index) => (
          <div key={index} className="m-2">
            <FunnelChartDigram
              data={data}
              title={titles[index]}
              onC2Click={handleC2Click}
            />
          </div>
        ))}
      </div>

      {isModalOpen && (
        <ModalMuiTable
          open={isModalOpen}
          heading={modalHeading}
          apiEndpoint={modalApi}
          sliceName={"filtersPipeline"}
          FilterComponent={PipelineFilter}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default MultipleFunnelCharts;
